import React from 'react';
import { useAITTheme, type AITTheme } from '@this/shared/ui/theme';
import { Link } from '@this/shared/ui/navigations/link';

type SummaryItem = {
  item_id: number;
  category: string;
  label: string;
  text: string;
  price: number | null;
  price_with_tax: number | null;
};

type Summary = {
  items: SummaryItem[];
  total_price: number;
  total_price_with_tax: number;
  has_selection: boolean;
};

interface Props {
  tripId: number;
  summary: Summary | null;
}
// 暫定バナー表示。デザイン、仕様等固まったら実装に合わせてこのファイルは適宜削除などを行うこと
const AiArrangementBanner = ({ tripId, summary }: Props) => {
  const { theme } = useAITTheme();
  const styles = getStyles(theme);

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <span style={styles.title}>AIチャットから手配申請済み</span>
        <Link href={`/trips/${tripId}/ai_messages`} style={styles.backLink}>
          AI手配画面に戻る
        </Link>
      </div>
      {summary && summary.has_selection && (
        <div style={styles.summary}>
          <div style={styles.summaryTitle}>【選択内容】</div>
          {summary.items.map(item => (
            <div key={item.item_id} style={styles.item}>
              <span style={styles.itemLabel}>{item.label}：</span>
              <span style={styles.itemText}>{item.text}</span>
              {item.price !== null && <span style={styles.itemPrice}>¥{item.price.toLocaleString()}</span>}
            </div>
          ))}
          <div style={styles.total}>合計金額：¥{summary.total_price.toLocaleString()}</div>
        </div>
      )}
    </div>
  );
};

const getStyles = (theme: AITTheme) => ({
  container: {
    backgroundColor: '#f0f7ff',
    border: '1px solid #90caf9',
    borderRadius: '8px',
    padding: '16px',
    marginBottom: '16px'
  } as const,
  header: {
    display: 'flex' as const,
    justifyContent: 'space-between' as const,
    alignItems: 'center' as const,
    marginBottom: '8px'
  } as const,
  title: {
    fontSize: '14px',
    fontWeight: 700 as const,
    color: '#1565c0'
  } as const,
  backLink: {
    fontSize: '12px',
    color: '#1565c0'
  } as const,
  summary: {
    backgroundColor: '#ffffff',
    border: '1px solid #bbdefb',
    borderRadius: '4px',
    padding: '12px',
    marginBottom: '12px',
    display: 'flex' as const,
    flexDirection: 'column' as const,
    gap: '8px'
  } as const,
  summaryTitle: {
    fontSize: '12px',
    fontWeight: 600 as const,
    color: '#555'
  } as const,
  item: {
    fontSize: '12px',
    color: '#333',
    display: 'flex' as const,
    gap: '4px',
    flexWrap: 'wrap' as const
  } as const,
  itemLabel: {
    fontWeight: 600 as const,
    color: '#555'
  } as const,
  itemText: {
    flex: 1 as const
  } as const,
  itemPrice: {
    color: '#666'
  } as const,
  total: {
    fontSize: '13px',
    fontWeight: 600 as const,
    color: '#333',
    borderTop: '1px solid #e3f2fd',
    paddingTop: '8px',
    marginTop: '4px'
  } as const
});

export default AiArrangementBanner;
